import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import StatusBadge from '../components/StatusBadge';
import { AISidebar, AIInsightCard } from '../components/ai';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Toggle } from '../components/ui/Toggle';
import { Button } from '../components/ui/Button';
import { ArrowLeft, Save, BarChart2, Settings, List, Upload, X } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { rewardsData } from '../utils/rewardsData';
// Mock redemptions log data
const mockRedemptionsLog = [{
  id: 'RC-2024-001',
  date: '2024-01-15 14:32',
  userId: 'USR-8A3F2',
  location: 'Milano Centro',
  method: 'Ritiro in Negozio',
  status: 'Utilizzato'
}, {
  id: 'RC-2024-002',
  date: '2024-01-14 16:20',
  userId: 'USR-7F3A9',
  location: 'Milano Centro',
  method: 'Ritiro in Negozio',
  status: 'Utilizzato'
}, {
  id: 'RC-2024-003',
  date: '2024-01-13 11:45',
  userId: 'USR-2D5E8',
  location: 'Milano Centro',
  method: 'Ritiro in Negozio',
  status: 'Riscattato'
}, {
  id: 'RC-2024-004',
  date: '2024-01-12 09:30',
  userId: 'USR-1C6D2',
  location: 'Roma Cola di Rienzo',
  method: 'Ritiro in Negozio',
  status: 'Utilizzato'
}, {
  id: 'RC-2024-005',
  date: '2024-01-11 15:20',
  userId: 'USR-3E7B9',
  location: 'Bologna',
  method: 'Ritiro in Negozio',
  status: 'Utilizzato'
}, {
  id: 'RC-2024-006',
  date: '2024-01-10 10:15',
  userId: 'USR-9B4C1',
  location: 'Milano Solari',
  method: 'Ritiro in Negozio',
  status: 'Riscattato'
}, {
  id: 'RC-2024-007',
  date: '2024-01-09 14:50',
  userId: 'USR-5K2L8',
  location: 'Firenze',
  method: 'Ritiro in Negozio',
  status: 'Utilizzato'
}, {
  id: 'RC-2024-008',
  date: '2024-01-08 16:30',
  userId: 'USR-6M3N9',
  location: 'Milano Centro',
  method: 'Ritiro in Negozio',
  status: 'Utilizzato'
}];
const RewardDetail = () => {
  const {
    rewardId
  } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'settings' | 'codes' | 'performance'>('settings');
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState<{
    message: string;
    show: boolean;
  }>({
    message: '',
    show: false
  });
  // Get reward data from mock
  const rewardData = rewardsData[rewardId as keyof typeof rewardsData];
  // State for image management
  const [rewardImage, setRewardImage] = useState<string>(rewardId === '1' ? 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&h=400&fit=crop' : rewardId === '2' ? 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=400&fit=crop' : rewardId === '3' ? 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=400&fit=crop' : rewardId === '4' ? 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=400&h=400&fit=crop' : rewardId === '5' ? 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=400&h=400&fit=crop' : rewardId === '6' ? 'https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=400&h=400&fit=crop' : rewardId === '7' ? 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=400&fit=crop' : rewardId === '8' ? 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400&h=400&fit=crop' : 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&h=400&fit=crop');
  const [imageUrl, setImageUrl] = useState<string>('');
  if (!rewardData) {
    return <div className="flex h-screen bg-gray-50" data-id="element-1610">
        <div className="w-20 flex-shrink-0" data-id="element-1611">
          <Sidebar data-id="element-1612" />
        </div>
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1613">
          <Topbar data-id="element-1614" />
          <main className="flex-1 overflow-y-auto p-6" data-id="element-1615">
            <div className="text-center py-12" data-id="element-1616">
              <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1617">
                Premio non trovato
              </h2>
              <button onClick={() => navigate('/rewards')} className="text-greenback hover:underline" data-id="element-1618">
                Torna ai premi
              </button>
            </div>
          </main>
        </div>
      </div>;
  }
  const [isActive, setIsActive] = useState(rewardData.status === 'Attivo');
  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setToast({
        message: 'Modifiche salvate',
        show: true
      });
      setTimeout(() => setToast({
        message: '',
        show: false
      }), 3000);
    }, 1000);
  };
  const handleApplyAiSuggestion = () => {
    setToast({
      message: 'Premio aggiornato con suggerimento AI',
      show: true
    });
    setTimeout(() => setToast({
      message: '',
      show: false
    }), 3000);
  };
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setRewardImage(reader.result as string);
        setToast({
          message: 'Immagine caricata con successo',
          show: true
        });
        setTimeout(() => setToast({
          message: '',
          show: false
        }), 3000);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageUrlChange = () => {
    if (imageUrl.trim()) {
      setRewardImage(imageUrl);
      setImageUrl('');
      setToast({
        message: 'Immagine aggiornata',
        show: true
      });
      setTimeout(() => setToast({
        message: '',
        show: false
      }), 3000);
    }
  };
  const handleRemoveImage = () => {
    setRewardImage('https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400&h=400&fit=crop');
    setToast({
      message: 'Immagine rimossa',
      show: true
    });
    setTimeout(() => setToast({
      message: '',
      show: false
    }), 3000);
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Utilizzato':
        return 'bg-green-100 text-green-800';
      case 'Riscattato':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Calculate utilization percentage
  const utilizationPercentage = rewardData.availability.unlimited ? 0 : (rewardData.availability.total - rewardData.availability.current) / rewardData.availability.total * 100;
  return <div className="flex h-screen bg-gray-50" data-id="element-1619">
      <div className="w-20 flex-shrink-0" data-id="element-1620">
        <Sidebar data-id="element-1621" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1622">
        <Topbar data-id="element-1623" />
        <main className="flex-1 overflow-y-auto p-6" data-id="element-1624">
          <div className="mb-6" data-id="element-1625">
            <button onClick={() => navigate('/rewards')} className="flex items-center text-sm text-gray-500 hover:text-gray-900 mb-4" data-id="element-1626">
              <ArrowLeft className="h-4 w-4 mr-1" data-id="element-1627" />
              Torna ai premi
            </button>

            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1628">
              <div data-id="element-1629">
                <div className="flex items-center gap-3 mb-1" data-id="element-1630">
                  <h1 className="text-2xl font-bold text-gray-900" data-id="element-1631">
                    {rewardData.name}
                  </h1>
                  <StatusBadge status={rewardData.status} type="reward" data-id="element-1632" />
                </div>
                <p className="text-sm text-gray-500" data-id="element-1633">
                  ID: {rewardData.id} • {rewardData.type}
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-1634">
                <div style={{
                background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 50%, rgba(116, 10, 214, 1) 100%)',
                padding: '2px',
                borderRadius: '100px'
              }} data-id="element-1635">
                  <button onClick={() => setIsAISidebarOpen(true)} className="text-black transition-colors flex items-center gap-1.5 bg-white px-3 py-1.5 hover:bg-gray-50" style={{
                  borderRadius: '100px'
                }} title="AI Insights" data-id="element-1636">
                    <span className="text-sm" data-id="element-1637">Suggerimenti AI</span>
                  </button>
                </div>
                <div className="flex items-center bg-white border border-gray-200 rounded-lg px-3 py-2" data-id="element-1638">
                  <span className="text-sm font-medium text-gray-700 mr-3" data-id="element-1639">
                    Stato:
                  </span>
                  <Toggle label="" checked={isActive} onChange={setIsActive} data-id="element-1640" />
                  <span className="text-sm text-gray-600 ml-2" data-id="element-1641">
                    {isActive ? 'Attivo' : 'Inattivo'}
                  </span>
                </div>
                <Button variant="primary" onClick={handleSave} isLoading={isLoading} leftIcon={<Save className="h-4 w-4" data-id="element-1643" />} data-id="element-1642">
                  Salva modifiche
                </Button>
              </div>
            </div>
          </div>

          {/* AI Insight Card */}
          {rewardData.aiHint && <div className="mb-6" data-id="element-1644">
              <AIInsightCard title="AI: Suggerimento per questo premio" insights={[rewardData.aiHint.text, rewardData.aiHint.explanation]} ctaLabel="Applica modifica" onCtaClick={handleApplyAiSuggestion} lastUpdated="Ultimi 7 giorni" data-id="element-1645" />
            </div>}

          {/* Tabs */}
          <div className="border-b border-gray-200 mb-6" data-id="element-1646">
            <nav className="-mb-px flex space-x-8" data-id="element-1647">
              <button onClick={() => setActiveTab('settings')} className={`flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'settings' ? 'border-greenback text-greenback' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1648">
                <Settings className="h-4 w-4 mr-2" data-id="element-1649" />
                Impostazioni
              </button>
              <button onClick={() => setActiveTab('codes')} className={`flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'codes' ? 'border-greenback text-greenback' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1650">
                <List className="h-4 w-4 mr-2" data-id="element-1651" />
                Codici / Disponibilità
              </button>
              <button onClick={() => setActiveTab('performance')} className={`flex items-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'performance' ? 'border-greenback text-greenback' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1652">
                <BarChart2 className="h-4 w-4 mr-2" data-id="element-1653" />
                Performance
              </button>
            </nav>
          </div>

          {/* Tab Content */}
          <div className="space-y-6" data-id="element-1654">
            {activeTab === 'settings' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1655">
                <div className="lg:col-span-2 space-y-6" data-id="element-1656">
                  {/* Image Upload Section */}
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1657">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1658">
                      Immagine Premio
                    </h3>
                    <div className="space-y-4" data-id="element-1659">
                      {/* Current Image Preview */}
                      <div className="flex items-start gap-4" data-id="element-1660">
                        <div className="relative" data-id="element-1661">
                          <img src={rewardImage} alt={rewardData.name} className="w-32 h-32 rounded-lg object-cover border-2 border-gray-200" data-id="element-1662" />
                          {rewardImage && <button onClick={handleRemoveImage} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors" title="Rimuovi immagine" data-id="element-1663">
                              <X className="h-4 w-4" data-id="element-1664" />
                            </button>}
                        </div>
                        <div className="flex-1" data-id="element-1665">
                          <p className="text-sm text-gray-600 mb-3" data-id="element-1666">
                            Carica un'immagine per il premio. Formato
                            consigliato: JPG, PNG. Dimensione massima: 5MB.
                          </p>
                          <label className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-1667">
                            <Upload className="h-4 w-4 mr-2" data-id="element-1668" />
                            Carica Immagine
                            <input type="file" accept="image/*" onChange={handleImageUpload} className="hidden" data-id="element-1669" />
                          </label>
                        </div>
                      </div>

                      {/* URL Input */}
                      <div className="pt-4 border-t border-gray-200" data-id="element-1670">
                        <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1671">
                          Oppure inserisci URL immagine
                        </label>
                        <div className="flex gap-2" data-id="element-1672">
                          <input type="url" value={imageUrl} onChange={e => setImageUrl(e.target.value)} placeholder="https://esempio.com/immagine.jpg" className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-1673" />
                          <button onClick={handleImageUrlChange} disabled={!imageUrl.trim()} className="px-4 py-2 bg-greenback text-white rounded-lg text-sm font-medium hover:bg-greenback-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1674">
                            Applica
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1675">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1676">
                      Informazioni Generali
                    </h3>
                    <div className="space-y-4" data-id="element-1677">
                      <Input label="Nome premio" defaultValue={rewardData.name} data-id="element-1678" />
                      <Textarea label="Descrizione breve" rows={3} defaultValue={rewardData.description} data-id="element-1679" />
                      <Textarea label="Termini e Condizioni" rows={3} defaultValue={rewardData.terms} data-id="element-1680" />
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1681">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1682">
                      Validità
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1683">
                      <Input label="Data inizio" type="date" defaultValue={rewardData.startDate || ''} data-id="element-1684" />
                      <Input label="Data fine" type="date" defaultValue={rewardData.endDate || ''} data-id="element-1685" />
                    </div>
                  </div>
                </div>

                <div className="space-y-6" data-id="element-1686">
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1687">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1688">
                      Configurazione
                    </h3>
                    <div className="space-y-4" data-id="element-1689">
                      <Input label="Costo in Punti" type="number" defaultValue={rewardData.cost} data-id="element-1690" />
                      <div className="pt-2" data-id="element-1691">
                        <Toggle label="Limite per utente" description="1 per utente" checked={rewardData.limitPerUser} onChange={() => {}} data-id="element-1692" />
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1693">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1694">
                      Sedi
                    </h3>
                    <div className="space-y-2" data-id="element-1695">
                      {rewardData.locations.map((location, index) => <div key={index} className="flex items-center" data-id="element-1696">
                          <input type="checkbox" checked className="h-4 w-4 text-greenback rounded border-gray-300" readOnly data-id="element-1697" />
                          <span className="ml-2 text-sm text-gray-700" data-id="element-1698">
                            {location}
                          </span>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>}

            {activeTab === 'codes' && <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1699">
                <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1700">
                  Codici e Disponibilità
                </h3>

                {/* Codice Premio */}
                <div className="mb-6" data-id="element-1701">
                  <Input label="Codice Premio" value={rewardData.code} readOnly data-id="element-1702" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-1703">
                    Codice univoco per identificare questo premio
                  </p>
                </div>

                {rewardData.availability.unlimited ? <div className="bg-blue-50 rounded-lg p-4 border border-blue-200" data-id="element-1704">
                    <p className="text-sm font-medium text-blue-900" data-id="element-1705">
                      Disponibilità Illimitata
                    </p>
                    <p className="text-sm text-blue-700 mt-1" data-id="element-1706">
                      Questo premio non ha limiti di disponibilità.
                    </p>
                  </div> : <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1707">
                      <Input label="Disponibilità Totale" value={rewardData.availability.total} readOnly data-id="element-1708" />
                      <Input label="Disponibilità Rimanente" value={rewardData.availability.current} readOnly data-id="element-1709" />
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1710">
                      <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1711">
                        Statistiche Utilizzo
                      </h4>
                      <div className="flex items-center justify-between text-sm" data-id="element-1712">
                        <span className="text-gray-500" data-id="element-1713">
                          Totale disponibile:
                        </span>
                        <span className="font-medium" data-id="element-1714">
                          {rewardData.availability.total}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm mt-2" data-id="element-1715">
                        <span className="text-gray-500" data-id="element-1716">Riscattati:</span>
                        <span className="font-medium text-green-600" data-id="element-1717">
                          {rewardData.availability.total - rewardData.availability.current}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm mt-2" data-id="element-1718">
                        <span className="text-gray-500" data-id="element-1719">Rimanenti:</span>
                        <span className="font-medium text-blue-600" data-id="element-1720">
                          {rewardData.availability.current}
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2 mt-3" data-id="element-1721">
                        <div className="bg-greenback h-2 rounded-full" style={{
                    width: `${utilizationPercentage}%`
                  }} data-id="element-1722"></div>
                      </div>
                      <p className="text-xs text-gray-500 mt-2" data-id="element-1723">
                        {utilizationPercentage.toFixed(0)}% utilizzato
                      </p>
                    </div>
                  </>}
              </div>}

            {activeTab === 'performance' && <div className="space-y-6" data-id="element-1724">
                {/* KPI Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1725">
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1726">
                    <p className="text-sm font-medium text-gray-500" data-id="element-1727">
                      Riscatti Totali
                    </p>
                    <p className="text-3xl font-bold text-gray-900 mt-2" data-id="element-1728">
                      {rewardData.redemptions.total}
                    </p>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-2" data-id="element-1729">
                      {rewardData.redemptions.period} questo periodo
                    </span>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1730">
                    <p className="text-sm font-medium text-gray-500" data-id="element-1731">
                      Punti Spesi
                    </p>
                    <p className="text-3xl font-bold text-gray-900 mt-2" data-id="element-1732">
                      {(rewardData.redemptions.total * rewardData.cost).toLocaleString()}
                    </p>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-2" data-id="element-1733">
                      Valore generato
                    </span>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1734">
                    <p className="text-sm font-medium text-gray-500" data-id="element-1735">
                      Ultimo Riscatto
                    </p>
                    <p className="text-3xl font-bold text-gray-900 mt-2" data-id="element-1736">
                      {rewardData.redemptions.lastRedemption}
                    </p>
                    <span className="text-sm text-gray-500 mt-2 block" data-id="element-1737">
                      {rewardData.location}
                    </span>
                  </div>
                </div>

                {/* Chart */}
                {rewardData.performanceData.length > 0 ? <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1738">
                    <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-1739">
                      Andamento Riscatti
                    </h3>
                    <div className="h-80" data-id="element-1740">
                      <ResponsiveContainer width="100%" height="100%" data-id="element-1741">
                        <AreaChart data={rewardData.performanceData} data-id="element-1742">
                          <defs data-id="element-1743">
                            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1" data-id="element-1744">
                              <stop offset="5%" stopColor="#1a4d2e" stopOpacity={0.1} data-id="element-1745" />
                              <stop offset="95%" stopColor="#1a4d2e" stopOpacity={0} data-id="element-1746" />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-1747" />
                          <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                      fill: '#6B7280',
                      fontSize: 12
                    }} dy={10} data-id="element-1748" />
                          <YAxis axisLine={false} tickLine={false} tick={{
                      fill: '#6B7280',
                      fontSize: 12
                    }} data-id="element-1749" />
                          <Tooltip contentStyle={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      border: '1px solid #E5E7EB',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                    }} data-id="element-1750" />
                          <Area type="monotone" dataKey="value" stroke="#1a4d2e" strokeWidth={2} fillOpacity={1} fill="url(#colorValue)" data-id="element-1751" />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div> : <div className="bg-white rounded-lg border border-gray-200 p-12 shadow-sm text-center" data-id="element-1752">
                    <p className="text-gray-500" data-id="element-1753">
                      Nessun dato disponibile. Il premio non ha ancora riscatti.
                    </p>
                  </div>}

                {/* Redemptions Log Table */}
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1754">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-1755">
                    <h3 className="text-lg font-semibold text-gray-900" data-id="element-1756">
                      Log Riscatti
                    </h3>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-1757">
                      Storico completo dei riscatti per questo premio
                    </p>
                  </div>
                  <div className="overflow-x-auto" data-id="element-1758">
                    <table className="w-full" data-id="element-1759">
                      <thead data-id="element-1760">
                        <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1761">
                          <th className="px-6 py-3" data-id="element-1762">ID Riscatto</th>
                          <th className="px-6 py-3" data-id="element-1763">Data/Ora</th>
                          <th className="px-6 py-3" data-id="element-1764">Utente</th>
                          <th className="px-6 py-3" data-id="element-1765">Sede</th>
                          <th className="px-6 py-3" data-id="element-1766">Metodo</th>
                          <th className="px-6 py-3" data-id="element-1767">Stato</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200" data-id="element-1768">
                        {mockRedemptionsLog.map(redemption => <tr key={redemption.id} className="hover:bg-gray-50 transition-colors" data-id="element-1769">
                            <td className="px-6 py-4" data-id="element-1770">
                              <span className="font-mono text-sm font-medium text-gray-900" data-id="element-1771">
                                {redemption.id}
                              </span>
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-600" data-id="element-1772">
                              {redemption.date}
                            </td>
                            <td className="px-6 py-4" data-id="element-1773">
                              <span className="font-mono text-sm text-gray-600" data-id="element-1774">
                                {redemption.userId}
                              </span>
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-600" data-id="element-1775">
                              {redemption.location}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-600" data-id="element-1776">
                              {redemption.method}
                            </td>
                            <td className="px-6 py-4" data-id="element-1777">
                              <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(redemption.status)}`} data-id="element-1778">
                                {redemption.status}
                              </span>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                  <div className="px-6 py-4 bg-gray-50 border-t border-gray-200" data-id="element-1779">
                    <p className="text-sm text-gray-500" data-id="element-1780">
                      Mostrando {mockRedemptionsLog.length} riscatti totali
                    </p>
                  </div>
                </div>
              </div>}
          </div>
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} title="Suggerimento AI per questo premio" data-id="element-1781">
        {rewardData.aiHint ? <AIInsightCard title="Suggerimento AI per questo premio" insights={[rewardData.aiHint.text, rewardData.aiHint.explanation]} ctaLabel="Applica modifica" onCtaClick={handleApplyAiSuggestion} lastUpdated="Ultimi 7 giorni" data-id="element-1782" /> : <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1783">
            <p className="text-sm text-gray-600" data-id="element-1784">
              Nessun suggerimento AI disponibile per questo premio al momento.
            </p>
          </div>}
      </AISidebar>

      {/* Toast Notification */}
      {toast.show && <div className="fixed bottom-6 right-6 bg-gray-900 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in" data-id="element-1785">
          {toast.message}
        </div>}
    </div>;
};
export default RewardDetail;